/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { Buffer } from 'buffer';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// The vendored rational-chat bundle expects a global Buffer.
if (!('Buffer' in globalThis)) {
  (globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;
}

// Local only: deployed apps must keep Cmd+C as plain copy, whatever the build configuration.
if (location.hostname.endsWith('.local.gkops.net')) {
  void import('@point-grab/angular').then((m) => m.initPointGrabAngular());
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
